import { create } from 'zustand'
import { getPurchasingReviewQueueCount } from '@/services/purchasing'

interface PurchasingNavState {
  /** Unfiltered needs_review queue row count. Null until first fetch resolves. */
  count: number | null
  fetchCount: () => Promise<void>
  setCount: (count: number) => void
  adjustCount: (delta: number) => void
}

export const usePurchasingNavStore = create<PurchasingNavState>((set) => ({
  count: null,

  fetchCount: async () => {
    try {
      const { count } = await getPurchasingReviewQueueCount()
      set({ count })
    } catch (e) {
      console.error('Failed to fetch purchasing review queue count:', e)
    }
  },

  setCount: (count) => set({ count }),

  adjustCount: (delta) =>
    set((state) => ({
      count: state.count == null ? state.count : Math.max(0, state.count + delta),
    })),
}))
